import { connect } from 'react-redux';

import LoginView from '../components/LoginView';

const mapActionCreators = {};

const mapStateToProps = state => ({});

export default connect(
    mapStateToProps,
    mapActionCreators
)(LoginView);
